import { Icon, type IconTone } from './Icon';

/** Кто это сделал: модератор под строкой решения. */
export function PersonIcon({ size, tone }: { size?: number; tone?: IconTone }) {
  return (
    <Icon size={size} box={12} tone={tone}>
      <circle cx="6" cy="4.2" r="2.1" strokeWidth={1} />
      <path d="M2.4 10.4 q3.6 -3.4 7.2 0" strokeWidth={1} />
    </Icon>
  );
}
